import React from 'react';
import { InstagramIcon, MessageCircleIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { whatsappLink } from '../lib/whatsapp';
import { useLanguage } from '../lib/i18n';
const scrollTo = (id: string) => {
  const el = document.querySelector(id);
  if (el) el.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
};
export function Footer() {
  const {
    t,
    lang
  } = useLanguage();
  const links = [{
    label: t('nav.home'),
    href: '#inicio'
  }, {
    label: t('nav.experiences'),
    href: '#experiencias'
  }, {
    label: t('nav.gallery'),
    href: '#galeria'
  }, {
    label: t('nav.reviews'),
    href: '#opiniones'
  }, {
    label: t('nav.contact'),
    href: '#contacto'
  }];
  return <footer className="bg-volcanic text-ivory px-5 sm:px-8 lg:px-24 pt-16 sm:pt-24 lg:pt-32 pb-8 sm:pb-12 w-full overflow-hidden" data-id="element-133">
      <div className="grid lg:grid-cols-12 gap-12 sm:gap-16 lg:gap-20 items-start max-w-[1400px] mx-auto" data-id="element-134">
        <div className="lg:col-span-5" data-id="element-135">
          <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4" data-id="element-136">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="sm:w-8 sm:h-8" data-id="element-137">
              <circle cx="12" cy="10" r="6" fill="#C97B63" fillOpacity="0.9" data-id="element-138" />
              <path d="M4 16C6 16 7 14 10 14C13 14 14 16 17 16C20 16 21 14 23 14" stroke="#7B8B6F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-139" />
              <path d="M2 19C4 19 5 17 8 17C11 17 12 19 15 19C18 19 19 17 21 17" stroke="#7B8B6F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.6" data-id="element-140" />
            </svg>
            <h3 className="font-display text-2xl sm:text-3xl lg:text-4xl leading-none font-light tracking-[0.15em]" data-id="element-141">
              YES PICNIC TENERIFE
            </h3>
          </div>
          <p className="font-script text-terracotta text-xl sm:text-2xl mb-6 sm:mb-8" data-id="element-142">
            Tenerife · luxury picnics
          </p>
          <p className="text-ivory/80 leading-relaxed max-w-sm text-[13px] sm:text-sm font-light" data-id="element-143">
            {t('footer.desc')}
          </p>
        </div>

        <div className="lg:col-span-3" data-id="element-144">
          <p className="uppercase tracking-[0.2em] text-[9px] sm:text-[10px] mb-5 sm:mb-6 text-ivory/60 font-semibold" data-id="element-145">
            {t('footer.nav')}
          </p>
          <ul className="space-y-3 sm:space-y-4 text-[13px] sm:text-sm font-light" data-id="element-146">
            {links.map(l => <li key={l.href} data-id="element-147">
                <a href={l.href} onClick={e => {
              e.preventDefault();
              scrollTo(l.href);
            }} className="inline-flex items-center group cursor-pointer hover:text-terracotta transition-colors duration-300" data-id="element-148">
                  <span className="w-0 h-px bg-terracotta group-hover:w-4 sm:group-hover:w-6 transition-all duration-500 mr-0 group-hover:mr-2 sm:group-hover:mr-3" data-id="element-149" />
                  <span data-id="element-150">{l.label}</span>
                </a>
              </li>)}
          </ul>
        </div>

        <div className="lg:col-span-4" data-id="element-151">
          <p className="uppercase tracking-[0.2em] text-[9px] sm:text-[10px] mb-5 sm:mb-6 text-ivory/60 font-semibold" data-id="element-152">
            {t('footer.contact')}
          </p>
          <div className="space-y-4 sm:space-y-5 text-[13px] sm:text-sm font-light" data-id="element-153">
            <a href="tel:+34689621262" className="flex items-center gap-3 hover:text-terracotta transition-colors duration-300" data-id="element-154">
              <PhoneIcon size={14} strokeWidth={1.5} className="sm:w-4 sm:h-4" data-id="element-155" />
              <span data-id="element-156">+34 689 621 262</span>
            </a>
            <a href="mailto:yes.picnic.tenerife@gmail.com" className="flex items-center gap-3 hover:text-terracotta transition-colors duration-300" data-id="element-157">
              <MailIcon size={14} strokeWidth={1.5} className="sm:w-4 sm:h-4" data-id="element-158" />
              <span data-id="element-159">yes.picnic.tenerife@gmail.com</span>
            </a>
            <a href={whatsappLink('general', lang)} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-terracotta transition-colors duration-300" data-id="element-160">
              <MessageCircleIcon size={14} strokeWidth={1.5} className="sm:w-4 sm:h-4" data-id="element-161" />
              <span data-id="element-162">{t('footer.wa')}</span>
            </a>
            <a href="https://www.instagram.com/yes.picnic.tenerife/" target="_blank" rel="noopener noreferrer" aria-label="Síguenos en Instagram @yes.picnic.tenerife" className="flex items-center gap-3 hover:text-terracotta transition-colors duration-300" data-id="element-163">
              <InstagramIcon size={14} strokeWidth={1.5} className="sm:w-4 sm:h-4" data-id="element-164" />
              <span data-id="element-165">@yes.picnic.tenerife</span>
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-ivory/10 mt-12 sm:mt-20 lg:mt-24 pt-8 sm:pt-10 flex flex-col md:flex-row justify-between items-center gap-4 sm:gap-6 text-center md:text-left text-[10px] sm:text-xs text-ivory/60 max-w-[1400px] mx-auto" data-id="element-166">
        <span className="uppercase tracking-[0.15em] sm:tracking-[0.2em] font-medium" data-id="element-167">
          {t('footer.copy')}
        </span>
        <span className="font-script text-terracotta text-base sm:text-lg capitalize tracking-normal" data-id="element-168">
          Made with love in Tenerife
        </span>
      </div>
    </footer>;
}